import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PictureAsPdf from '@mui/icons-material/PictureAsPdf';
import { Grid, IconButton, TableHead, Typography } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import DialogContent from '@mui/material/DialogContent';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import { getAdminDocs, getPdf, saveAdminDocs } from '../../../services/AdminServices';
import UserDataPDF from './UserDataPDF';
import { Fragment, useEffect, useState } from 'react';
import { getAvanseLoan } from '../../../services/avanseService';


export default function AdminLenderLoanDetails(props) {
    const { selectedRow, shouldFetch, setShouldFetch } = props;
    const [avanseLoanResponse, setAvanseLoanResponse] = useState(null)
    const [breResponse, setBreResponse] = useState(null)
    const [columnsLeft, setColumnsLeft] = useState([])
    const [columnsRight, setColumnsRight] = useState([])
    const [showPDFView, setShowPDFView] = useState(false);
    const [pdf, setPdf] = useState(null);
 



    useEffect(() => {
        (async () => {
            const resp = await getAvanseLoan(selectedRow?.detailId)
            console.log("resp1", resp, JSON.parse(JSON.stringify(resp.response.breResponseJson)))
            setAvanseLoanResponse(resp.response)
            setBreResponse(JSON.parse(resp.response.breResponseJson))
            setShouldFetch(false)
        })();
    }, [shouldFetch, selectedRow?.detailId])

    useEffect(() => {
        if(!avanseLoanResponse) {
            return;
        }

        const leftCols = [
            { label: "Application No", value: avanseLoanResponse?.applicationNo },
            { label: "Unique Lead ID", value: avanseLoanResponse?.uniqueLeadId },
            { label: "LAN (Loan Account Number)", value: avanseLoanResponse?.lan },
            { label: "CIF", value: avanseLoanResponse?.cif },
            { label: "Loan Amount", value: Math.ceil(avanseLoanResponse?.loanAmount / 100) },
            { label: "Tenure (Months)", value: avanseLoanResponse?.tenureMonths },
            { label: "EMI Amount", value: Math.ceil(avanseLoanResponse?.emiAmount / 100) },
            { label: "ROI (%)", value: avanseLoanResponse?.roi },
            { label: "APR (%)", value: avanseLoanResponse?.apr },
            { label: "Total Interest", value: Math.ceil(avanseLoanResponse?.totalInterest / 100) },
            { label: "Processing Fee", value: Math.ceil(avanseLoanResponse?.processingFeeAmount / 100) },
            { label: "Avanse Agreement PDF", value: avanseLoanResponse?.loanAgreementUrl, pdf: true },
            { label: "Avanse KFS PDF", value: avanseLoanResponse?.kfsPdfUrl, pdf: true },
        ]

        const rightCols = [
            { label: "BRE Status", value: avanseLoanResponse?.breStatus },
            { label: "VKYC Status", value: avanseLoanResponse?.vkycStatus },
            { label: "Application Created At", value: avanseLoanResponse?.applicationCreatedAt },
            { label: "Sanction Letter Date", value: avanseLoanResponse?.sanctionLetterDate },
            { label: "Finance Start Date", value: avanseLoanResponse?.financeStartDate },
            { label: "First Repayment Date", value: avanseLoanResponse?.firstRepaymentDate },
            { label: "Last Repay Date", value: avanseLoanResponse?.lastRepayDate },
            { label: "Outstanding Principal", value: Math.ceil(avanseLoanResponse?.outstandingPrincipal / 100) },
            { label: "Total Repay Amount", value: Math.ceil(avanseLoanResponse?.totalRepayAmount / 100) },
            { label: "UTR Number", value: avanseLoanResponse?.utrNumber ?? "--" },
            { label: "Mandate Status", value: avanseLoanResponse?.mandateStatus },
            { label: "Payment Status", value: avanseLoanResponse?.paymentStatus },
            { label: "Agreement Status", value: avanseLoanResponse?.agreementStatus },
            { label: "Avanse Agreement No", value: avanseLoanResponse?.avanseAgreementNo },

        ]

        setColumnsLeft(leftCols)
        setColumnsRight(rightCols)

    }, [avanseLoanResponse])
    
    async function getUserPdf(url, e) {
        e?.preventDefault()
        const splitFile = JSON.stringify(url).split("/")
        const obj = {
            fileName: url
        }
        const dFile = await getPdf(obj);
        setShowPDFView(true)
        const blob = base64ToBlob(dFile?.data.split(',')[1], 'application/pdf');
        const pdfurl = URL.createObjectURL(blob);
        setPdf(pdfurl);

    }

    function base64ToBlob(base64, type = "application/octet-stream") {
        const binStr = atob(base64);
        const len = binStr.length;
        const arr = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
            arr[i] = binStr.charCodeAt(i);
        }
        return new Blob([arr], { type: type });
    }
   

    function getEventBody() {
        const rows = [];

        {breResponse && Object.entries(breResponse).map(([key, value]) => (
            rows.push(
                <TableRow>
                    <TableCell sx={{ borderLeft: "0.1px inset gray", borderRight: "0.1px inset gray", borderBottom: "0.1px inset gray" }} component="th" scope="row">
                        {key}
                    </TableCell>
                    <TableCell sx={{ borderRight: "0.1px inset gray", borderBottom: "0.1px inset gray" }} component="th" scope="row">
                        {value ?? "--"}
                    </TableCell>
                </TableRow>

            )))
        }
        return rows;
    }


    return (
        <Fragment>
            <DialogContent>
                <Accordion>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                    >
                        <Typography>Lender Loan Details</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                            <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                                <Grid item xs={6}>
                                    <TableContainer sx={{ maxHeight: 440 }}>
                                        <Table>
                                            <TableBody>
                                                {columnsLeft.map((col) => {
                                                    return (
                                                        <TableRow >

                                                            <TableCell>
                                                                {col?.label}
                                                            </TableCell>
                                                             <TableCell >
                                                                {col?.pdf ? <TableCell>
                                                                <IconButton
                                                                    edge="start"
                                                                    color="inherit"
                                                                    onClick={(e) => getUserPdf(col?.value, e)}
                                                                    aria-label="PDF"
                                                                >
                                                                    <PictureAsPdf />
                                                                </IconButton>
                                                            </TableCell> : <TableCell >
                                                                {col?.value}
                                                            </TableCell>}
                                                            
                                                            </TableCell>
                                                        </TableRow>
                                                    );
                                                })}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Grid>

                                <Grid item xs={6}>
                                    <TableContainer sx={{ maxHeight: 440 }}>
                                        <Table>
                                            <TableBody>
                                                {columnsRight.map((col) => {
                                                    return (
                                                        <TableRow >

                                                            <TableCell>
                                                                {col?.label}
                                                            </TableCell>
                                                             <TableCell >
                                                                {col?.value}
                                                            </TableCell>
                                                        </TableRow>
                                                    );
                                                })}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Grid>
                                
                            </Grid>
                            <Grid  item xs={6}>

                                <TableContainer sx={{ maxHeight: 440 }}>
                                    <Table stickyHeader>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell sx={{ borderRight: "0.1px inset gray", borderLeft: "0.1px inset gray", borderTop: "0.1px inset gray", borderBottom: "0.1px inset gray", fontWeight: "bold", backgroundColor: "#E5E5E5" }}>BRE Rules#</TableCell>
                                                <TableCell sx={{ borderRight: "0.1px inset gray", borderTop: "0.1px inset gray", borderBottom: "0.1px inset gray", fontWeight: "bold", backgroundColor: "#E5E5E5" }} >Status</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {getEventBody()}
                                        </TableBody>
                                    </Table>
                                </TableContainer>

                            </Grid>
                            
                        </Paper>
                    </AccordionDetails>
                </Accordion>

            </DialogContent>
        {
            showPDFView &&
            <UserDataPDF open={showPDFView} setOpen={setShowPDFView} pdf={pdf} setPdf={setPdf} />
        }    

        </Fragment>
    );
}
